// assets/urgency-box.js
document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_PREFIX = "urgencyMessage_";
  const DEFAULT_DURATION_HOURS = 4;
  const DEFAULT_DURATION_MS = DEFAULT_DURATION_HOURS * 60 * 60 * 1000;


  const initUrgencyBox = () => {
    const wrapper = document.getElementById("urgency-wrapper");
    if (!wrapper) return;

    // --- Clean expired urgency messages from localStorage ---
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(STORAGE_PREFIX)) {
        try {
          const item = JSON.parse(localStorage.getItem(key) || "{}");
          if (item.timestamp && Date.now() - item.timestamp > DEFAULT_DURATION_MS) {
            localStorage.removeItem(key);
          }
        } catch (err) {
          // In case of invalid JSON, remove the corrupted entry
          localStorage.removeItem(key);
        }
      }
    });

    // --- Get collections from data attribute (injected via Liquid) ---
    const collections = (wrapper.dataset.collections || "")
      .split(",")
      .map((c) => c.trim().toLowerCase())
      .filter(Boolean);

    // console.log("🔥 Urgency Box initialized for:", collections);

    // --- CONFIGURATION PER COLLECTION ---
    const COLLECTION_CONFIG = {
      "chrome-hearts": {
        priority: 1,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "FREE DELIVERY + 100% AUTHENTIC",
          "POPULAR! {5-50} OTHERS RECENTLY VIEWED",
          "TRENDING NOW! {100-300} VIEWS IN THE PAST DAY",
          "POPULAR! {5-10} OTHERS LOOKING AT THIS RIGHT NOW"
        ]
      },
      "streetwear-collection": {
        priority: 2,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "GOOD CHOICE! LAST BOUGHT {10-50} MINUTES AGO",
          "SELLING FAST! - DONT MISS OUT",
          "POPULAR! {5-50} OTHERS RECENTLY VIEWED",
          "POPULAR! {5-10} OTHERS LOOKING AT THIS RIGHT NOW",
          "TRENDING NOW! {100-300} VIEWS IN THE PAST DAY",
          "TRENDING NOW! {5-10} BOUGHT IN THE LAST 24 HOURS"
        ]
      },
      "activewear": {
        priority: 3,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "GOOD CHOICE! LAST BOUGHT {10-50} MINUTES AGO",
          "SELLING FAST! - DONT MISS OUT",
          "POPULAR! {5-50} OTHERS RECENTLY VIEWED",
          "POPULAR! {5-10} OTHERS LOOKING AT THIS RIGHT NOW",
          "TRENDING NOW! {100-300} VIEWS IN THE PAST DAY",
          "TRENDING NOW! {5-10} BOUGHT IN THE LAST 24 HOURS"
        ]
      },
      "exclusive": {
        priority: 4,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "GOOD CHOICE! LAST BOUGHT {10-50} MINUTES AGO",
          "SELLING FAST! - DONT MISS OUT",
          "TRENDING! {5-10} BOUGHT IN THE LAST 24 HOURS",
          "POPULAR! {5-50} OTHERS RECENTLY VIEWED",
          "POPULAR! {5-50} OTHERS LOOKING AT THIS RIGHT NOW",
          "TRENDING NOW! {100-300} VIEWS IN THE PAST DAY"
        ]
      },
      "best-sellers": {
        priority: 5,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "GOOD CHOICE! LAST BOUGHT {1-30} MINUTES AGO",
          "SELLING FAST! - DONT MISS OUT",
          "TRENDING NOW! {20-50} BOUGHT IN THE LAST 24 HOURS",
          "TRENDING NOW! {300-500} VIEWS IN THE PAST DAY",
          "POPULAR! {5-50} OTHERS LOOKING AT THIS RIGHT NOW"
        ]
      },

      // --- DEFAULT fallback ---
      DEFAULT: {
        priority: 7,
        durationHours: DEFAULT_DURATION_HOURS,
        messages: [
          "GOOD CHOICE! LAST BOUGHT {30-55} MINUTES AGO",
          "SELLING FAST! - DONT MISS OUT",
          "POPULAR! {5-50} OTHERS RECENTLY VIEWED",
          "POPULAR! {5-10} OTHERS LOOKING AT THIS RIGHT NOW",
          "TRENDING NOW! {5-10} BOUGHT IN THE LAST 24 HOURS",
          "TRENDING NOW! {100-300} VIEWS IN THE PAST DAY"
        ]
      }
    };

    // --- Helper functions ---
    const getRandomInt = (min, max) =>
      Math.floor(Math.random() * (max - min + 1)) + min;

    const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

    const parseDynamicNumbers = (msg) =>
      msg.replace(/\{(\d+)-(\d+)\}/g, (_, min, max) =>
        getRandomInt(parseInt(min), parseInt(max))
      );

    // --- Find matching collections with priority (case-insensitive + tolerant to dashes/spaces) ---
    const normalize = (str) => str.replace(/[-_]/g, " ").trim().toLowerCase();

    // Create a lookup map: normalized key → original key
    const configMap = Object.keys(COLLECTION_CONFIG).reduce((map, key) => {
      map[normalize(key)] = key;
      return map;
    }, {});

    // Collect all matching collections with their priorities
    const matchedCollections = collections
      .map((c) => {
        const normalized = normalize(c);
        const originalKey = configMap[normalized];
        if (originalKey && COLLECTION_CONFIG[originalKey]) {
          return {
            key: originalKey,
            priority: COLLECTION_CONFIG[originalKey].priority || 0 // default 0 if not set
          };
        }
        return null;
      })
      .filter(Boolean);

    // Select the highest priority, fallback to DEFAULT
    let matchedCollection = "DEFAULT";
    if (matchedCollections.length > 0) {
      matchedCollections.sort((a, b) => a.priority - b.priority);
      matchedCollection = matchedCollections[0].key;
    }

    // --- Determine product identifier ---
    const productHandle =
      wrapper.dataset.productHandle || wrapper.dataset.productId || "unknown-product";

    // --- Build per-product storage key ---
    const STORAGE_KEY = `${STORAGE_PREFIX}${productHandle}`;

    const { messages: messageOptions } = COLLECTION_CONFIG[matchedCollection];
    const DURATION_MS = DEFAULT_DURATION_MS;

    // Define SVG icons (moved here to be accessible for storage)
    const svgIcons = [
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M144 224C161.7 224 176 238.3 176 256L176 512C176 529.7 161.7 544 144 544L96 544C78.3 544 64 529.7 64 512L64 256C64 238.3 78.3 224 96 224L144 224zM334.6 80C361.9 80 384 102.1 384 129.4L384 133.6C384 140.4 382.7 147.2 380.2 153.5L352 224L512 224C538.5 224 560 245.5 560 272C560 291.7 548.1 308.6 531.1 316C548.1 323.4 560 340.3 560 360C560 383.4 543.2 402.9 521 407.1C525.4 414.4 528 422.9 528 432C528 454.2 513 472.8 492.6 478.3C494.8 483.8 496 489.8 496 496C496 522.5 474.5 544 448 544L360.1 544C323.8 544 288.5 531.6 260.2 508.9L248 499.2C232.8 487.1 224 468.7 224 449.2L224 262.6C224 247.7 227.5 233 234.1 219.7L290.3 107.3C298.7 90.6 315.8 80 334.6 80z"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M434.8 54.1C446.7 62.7 451.1 78.3 445.7 91.9L367.3 288L512 288C525.5 288 537.5 296.4 542.1 309.1C546.7 321.8 542.8 336 532.5 344.6L244.5 584.6C233.2 594 217.1 594.5 205.2 585.9C193.3 577.3 188.9 561.7 194.3 548.1L272.7 352L128 352C114.5 352 102.5 343.6 97.9 330.9C93.3 318.2 97.2 304 107.5 295.4L395.5 55.4C406.8 46 422.9 45.5 434.8 54.1z"/></svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M256.5 37.6C265.8 29.8 279.5 30.1 288.4 38.5C300.7 50.1 311.7 62.9 322.3 75.9C335.8 92.4 352 114.2 367.6 140.1C372.8 133.3 377.6 127.3 381.8 122.2C382.9 120.9 384 119.5 385.1 118.1C393 108.3 402.8 96 415.9 96C429.3 96 438.7 107.9 446.7 118.1C448 119.8 449.3 121.4 450.6 122.9C460.9 135.3 474.6 153.2 488.3 175.3C515.5 219.2 543.9 281.7 543.9 351.9C543.9 475.6 443.6 575.9 319.9 575.9C196.2 575.9 96 475.7 96 352C96 260.9 137.1 182 176.5 127C196.4 99.3 216.2 77.1 231.1 61.9C239.3 53.5 247.6 45.2 256.6 37.7zM321.7 480C347 480 369.4 473 390.5 459C432.6 429.6 443.9 370.8 418.6 324.6C414.1 315.6 402.6 315 396.1 322.6L370.9 351.9C364.3 359.5 352.4 359.3 346.2 351.4C328.9 329.3 297.1 289 280.9 268.4C275.5 261.5 265.7 260.4 259.4 266.5C241.1 284.3 207.9 323.3 207.9 370.8C207.9 439.4 258.5 480 321.6 480z"/></svg>'
    ];

    // --- Retrieve or generate persistent message and icon per product ---
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const now = Date.now();
    let message;
    let iconIndex;
    let template;

    if (stored.timestamp && stored.message && stored.iconIndex !== undefined && stored.template && now - stored.timestamp < DURATION_MS) {
      // Keep existing message, icon AND template for this product
      message = stored.message;
      iconIndex = stored.iconIndex;
      template = stored.template;
    } else {
      // Generate new message, icon AND template for this product and save
      const selectedMessage = pickRandom(messageOptions);
      message = parseDynamicNumbers(selectedMessage);
      iconIndex = Math.floor(Math.random() * svgIcons.length);

      // Randomly select template: 'red' or 'grey' (50/50 chance)
      template = Math.random() < 0.5 ? 'red' : 'grey';

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ timestamp: now, message, iconIndex, template })
      );
    }

    console.log('Urgency message:', message, 'Icon index:', iconIndex, 'Template:', template); // Debug log

    // --- Animation control ---
    const renderUrgencyBox = (message, iconIndex, template) => {
      // Validate message exists
      if (!message || typeof message !== 'string' || message === 'undefined') {
        console.error('Invalid message:', message);
        return;
      }

      // Use the stored icon index
      const selectedIcon = svgIcons[iconIndex];

      wrapper.innerHTML = "";
      const box = document.createElement("div");
      box.className = "urgency-box slide-down";

      // Apply template class
      if (template === 'grey') {
        box.classList.add('template-grey');
      }

      // Create icon container
      const iconContainer = document.createElement("span");
      iconContainer.className = "urgency-icon";
      iconContainer.innerHTML = selectedIcon;

      // Create text container
      const textSpan = document.createElement("span");
      textSpan.className = "urgency-text";
      textSpan.innerHTML = message;

      box.appendChild(iconContainer);
      box.appendChild(textSpan);
      wrapper.appendChild(box);
    };

    // Mark that urgency box has been shown for this page load
    let hasShown = false;

    // Wait 2 seconds before showing the alert
    setTimeout(() => {
      if (hasShown) return;
      hasShown = true;

      renderUrgencyBox(message, iconIndex, template);

      // Auto-hide after 5 seconds
      // Show for 5 seconds, then fade out and remove
      setTimeout(() => {
        const box = wrapper.querySelector(".urgency-box");
        if (box) {
          box.classList.add("fade-out");

          // Remove after fade animation completes
          setTimeout(() => {
            wrapper.innerHTML = "";
          }, 600);
        }
      }, 5000);
    }, 2000);
  };

  // --- Wait for wrapper to exist ---
  const waitForWrapper = () => {
    const wrapper = document.getElementById("urgency-wrapper");
    if (!wrapper) {
      setTimeout(waitForWrapper, 200);
      return;
    }
    initUrgencyBox();

    // Disabled: Shopify dynamic reload watcher
    // The urgency box should only appear once per page load
    // and not reappear after disappearing
  };

  waitForWrapper();
});
